import { render, staticRenderFns } from "./SmtpProviderSelectBox.vue?vue&type=template&id=2f00dab7&scoped=true&"
import script from "./SmtpProviderSelectBox.vue?vue&type=script&lang=js&"
export * from "./SmtpProviderSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00dab7",
  null
  
)

export default component.exports